import moment from 'moment-timezone';
import { TZ } from '../../constants';
export default function TimeFormat({ time, type  }) {
  return type === 1 ?  moment(time).utc(false).tz(TZ).format('DD/MM/YYYY') : moment(time).utc(false).tz(TZ).format('DD/MM/YYYY hh:mm A') + ' SGT' || "-"
}
